import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Heart } from 'lucide-react';

const Footer = () => {
  const { t, isBangla, hasSelectedLanguage } = useLanguage();

  if (!hasSelectedLanguage) return null;

  return (
    <footer 
      className="py-10 sm:py-12 px-4 bg-[#2D2424] text-white/80"
      data-testid="footer"
    >
      <div className="max-w-4xl mx-auto text-center">
        {/* Decorative line */}
        <div className="w-20 sm:w-24 mx-auto h-0.5 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mb-6 sm:mb-8" />
        
        {/* Names */}
        <h3 className={`font-heading text-2xl sm:text-3xl text-[#D4AF37] mb-3 ${isBangla ? 'font-bangla' : ''}`}>
          {t('footerNames')}
        </h3>
        
        {/* Date */}
        <p className={`text-white/60 text-sm sm:text-base mb-4 ${isBangla ? 'font-bangla' : ''}`}>
          {t('heroSubtitle')}
        </p>
        
        {/* Made with love */}
        <div className="flex items-center justify-center gap-2 text-white/50 text-xs sm:text-sm">
          <span className={isBangla ? 'font-bangla' : ''}>{t('madeWith')}</span>
          <Heart className="w-3 h-3 sm:w-4 sm:h-4 text-[#800020] fill-[#800020]" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
